import React, {useState} from 'react'
import {Button, Card, Col, Form, Image, InputGroup, Row} from 'react-bootstrap'
import {toast} from 'react-toastify';
import {update_invoice_approvalStatus} from '../../helper/Api';
import {AddCommasToAmount, getActiveInvoiceDeductions, get_file_ext} from '../../helper/Utils';
import {extractDocumentServePath, openSecureDocumentOrToast} from '../../helper/secureDocuments';
import {useSelector} from 'react-redux';
import ApprovalFundPreview from "../Modal/ApprovalFundPreview";
import moment from "moment";
import { Accordion } from "react-bootstrap";
import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from "@mui/material";


const ProceedForApproval = ({invoice, setInvoices, index}) => {
    const [data, setData] = useState(invoice);
    const [preview, setPreview] = useState(invoice.sanction_order);
    const {authData} = useSelector((state) => state.authData);
    const [showPreview, setShowPreview] = useState(false);
    const [remarks, setRemarks] = useState(data.remarks ? data.remarks : '');
    const [l2remarks, setl2Remarks] = useState(data.l2remarks ? data.l2remarks : '');
    const [l3remarks, setl3Remarks] = useState(data.l3remarks ? data.l3remarks : '');
    const [schemeStatus, setSchemeStatus] = useState('');
    const [activeKeys, setActiveKeys] = useState([]);
    const [activeCard, setActiveCard] = useState([]);
    const activeDeductions = getActiveInvoiceDeductions({
        ...(data || {}),
        ...(data?.invoice_deduction_details || {}),
    });
    const distinctSchemeList = (data?.scheme_list || []).filter(
        (scheme, schemeIndex, allSchemes) =>
            allSchemes.findIndex((currentScheme) => currentScheme?.id === scheme?.id) === schemeIndex,
    );

    const mainCardSwitch = (val1, val2, val3, detailObj) => {
        setActiveCard((prev) => {
        let updated = [...prev];
        updated = updated.filter(item => item !== val2 && item !== val3);
        if (!updated.includes(val1)) {
            updated.unshift(val1);
        }
        return updated;
        });
    };
    const toggleAccordion = (key) => {
        setActiveKeys(
        (prevKeys) =>
            prevKeys.includes(key)
            ? prevKeys.filter((k) => k !== key) // Remove key if it's already open
            : [...prevKeys, key] // Add key if it's closed
        );
    };
    const hasStoredDocument = (value) => {
        if (value == null) return false;
        const text = String(value).trim();
        if (!text || text === '0' || text.toLowerCase() === 'null' || text.toLowerCase() === 'undefined') return false;
        if (/^https?:\/\//i.test(text) && !extractDocumentServePath(text)) return false;
        return true;
    };
    const openApprovalDocument = (event, type, value) => {
        event.preventDefault();
        if (extractDocumentServePath(value)) {
            openSecureDocumentOrToast(value);
            return;
        }
        const ids = {
            sanction_order: data?.sanction_order_id || data?.sanction_id,
            voucher: data?.voucher_id,
            invoice: data?.invoice_id || data?.id,
            invoice_ref: data?.invoice_id || data?.id,
        };
        const resources = {
            sanction_order: 'sanction_order',
            voucher: 'voucher',
            invoice: 'invoice',
            invoice_ref: 'invoice',
        };
        const fields = {
            sanction_order: 'sanction_order',
            voucher: 'voucher',
            invoice: 'invoice',
            invoice_ref: 'invoice_ref',
        };
        const id = ids[type];
        if (!id) {
            toast.error('Document unavailable', { position: toast.POSITION.TOP_CENTER });
            return;
        }
        openSecureDocumentOrToast(`documents/serve/${resources[type]}/${id}/${fields[type]}`);
    };
    const groupActivitiesByName = (subheads = []) => {
        const grouped = {};

        subheads.forEach((subhead) => {
        (subhead?.activities || []).forEach((activityItem) => {
            const groupKey = `${activityItem?.activity_id || ""}_${activityItem?.activity || ""}`;

            if (!grouped[groupKey]) {
            grouped[groupKey] = {
                activity_id: activityItem?.activity_id,
                activity: `${subhead.name} || ${activityItem?.activity}`,
                subactivities: []
            };
            }

            const alreadyExists = grouped[groupKey].subactivities.some(
            (subactivityItem) => subactivityItem?.subactivity_id === activityItem?.subactivity_id
            );

            if (!alreadyExists) {
            grouped[groupKey].subactivities.push(activityItem);
            }
        });
        });

        return Object.values(grouped);
    };

    const update_approvalStatus = async () => {
        if (schemeStatus == 2 && (authData.user.user_type === 'l2' && (l2remarks.trim() == '' || l2remarks.trim() == null)) || (authData.user.user_type === 'l3' && (l3remarks.trim() == '' || l3remarks.trim() == null))) {
            toast.error('Remarks Field required... ', {
                position: toast.POSITION.TOP_CENTER
            });
        } else {
            let post_data = {
                'invoice_id': data.id,
                'remarks': remarks,
                'l2remarks': l2remarks,
                'l3remarks': l3remarks,
            };
            if (authData.user.user_type === 'l3') {
                post_data.l3_approval_status = schemeStatus;
            } else if (authData.user.user_type === 'l2') {
                post_data.approval_status = schemeStatus;
            }

            const status_response = await update_invoice_approvalStatus(post_data)
            if (status_response.data.status) {
                setShowPreview(false);
                setData(status_response.data.list[0])
                if (schemeStatus == 2) {
                    toast.error(status_response.data.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                } else {
                    toast.success(status_response.data.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }

                setInvoices(prevArray => {
                    const newArray = [...prevArray];
                    newArray[index] = status_response.data.list[0];
                    return newArray;
                });

            } else {
                setShowPreview(false);
                toast.error(status_response.data.message, {
                    position: toast.POSITION.TOP_CENTER
                });

            }
        }
    }
    const exts = ['jpeg', 'jpg', 'png'];
    const previewHandler = (e) => {
        if (e && typeof e.preventDefault === 'function') {
            e.preventDefault();
        }
        setSchemeStatus(e);
        setShowPreview(true);

    };

    return (
        <div>
            <ApprovalFundPreview
                showPreview={showPreview}
                setShowPreview={setShowPreview}
                formData={data}
                remarks={remarks}
                l2remarks={l2remarks}
                l3remarks={l3remarks}
                actionStatus={schemeStatus}
                invoiceIndex={index}
                handleSubmit={update_approvalStatus}/>
            <Card className="p-4">
                <div className="border-bottom">
                    <Row>
                        <div className="row px-2">
                            <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                                <span className="fs-12px text-black-60">
                                Sanction Order No:
                                </span>
                                <span className="fs-14px fw-500">{data?.sanction_order_no}</span>
                            </div>
                            <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                                <span className="fs-12px text-black-60">
                                Sanction Order Date:
                                </span>
                                <span className="fs-14px fw-500">{moment(data?.sanction_order_date,'YYYY-MM-DD').format('DD-MM-YYYY')}</span>
                            </div>
                            <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                                <span className="fs-12px text-black-60">
                                Sanction Order Amount:
                                </span>
                                <span className="fs-14px fw-500">{AddCommasToAmount(data?.sanction_amount)}</span>
                            </div>
                            <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                                {hasStoredDocument(data?.sanction_order) && (
                                <a
                                    href="#"
                                    role="button"
                                    style={{color: 'black'}}
                                    onClick={(e) => openApprovalDocument(e, 'sanction_order', data?.sanction_order)}
                                ><i className="icon-picture_as_pdf fs-18px text-danger-100"></i></a>
                                )}
                            </div>
                        </div>
                        <div className="row px-2">
                            <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                                <span className="fs-12px text-black-60">Voucher No:</span>
                                <span className="fs-14px fw-500">{data?.voucher_no}</span>
                            </div>
                            <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                                <span className="fs-12px text-black-60">Voucher Date:</span>
                                <span className="fs-14px fw-500">{moment(data?.voucher_date,'YYYY-MM-DD').format('DD-MM-YYYY')}</span>
                            </div>
                            <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                                <span className="fs-12px text-black-60">Voucher Amount:</span>
                                <span className="fs-14px fw-500">{AddCommasToAmount(data?.voucher_amount)}</span>
                            </div>
                            <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                                {hasStoredDocument(data?.voucher) && (
                                <a
                                    href="#"
                                    role="button"
                                    style={{color: 'black'}}
                                    onClick={(e) => openApprovalDocument(e, 'voucher', data?.voucher)}
                                ><i className="icon-picture_as_pdf fs-18px text-danger-100"></i></a>
                                )}
                            </div>
                        </div>
                            <div className="row px-2">
                            <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                                <span className="fs-12px text-black-60">Invoice No:</span>
                                <span className="fs-14px fw-500">{data?.invoice_no}</span>
                            </div>
                            <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                                <span className="fs-12px text-black-60">Invoice Date:</span>
                                <span className="fs-14px fw-500">{moment(data?.invoice_date,'YYYY-MM-DD').format('DD-MM-YYYY')}</span>
                            </div>
                            <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                                <span className="fs-12px text-black-60">Vendor Name:</span>
                                <span className="fs-14px fw-500">{data?.beneficiary_other_details?.beneficiary_company_name}</span>
                            </div>
                            <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                                {hasStoredDocument(data?.invoice) && (
                                <a
                                    href="#"
                                    role="button"
                                    style={{color: 'black'}}
                                    onClick={(e) => openApprovalDocument(e, 'invoice', data?.invoice)}
                                ><i className="icon-picture_as_pdf fs-18px text-danger-100"></i></a>
                                )}
                                {hasStoredDocument(data?.invoice_ref) && (
                                    <a
                                        href="#"
                                        role="button"
                                        style={{color: 'black'}}
                                        onClick={(e) => openApprovalDocument(e, 'invoice_ref', data?.invoice_ref)}
                                    ><i className="icon-picture_as_pdf fs-18px text-danger-100"></i></a>
                                )}
                            </div>
                        </div>
                        <div className="row px-2">
                            <div className="col-6 col-md-2 m-0 p-0 d-flex gap-1 p-2 flex-column">
                                <span className="fs-12px text-black-60">Taxable Amount</span>
                                <span className="fs-14px fw-500">{AddCommasToAmount(data?.taxable_amount)}</span>
                            </div>
                            <div className="col-6 col-md-2 m-0 p-0 d-flex gap-1 p-2 flex-column">
                                <span className="fs-12px text-black-60">GST</span>
                                <span className="fs-14px fw-500">{AddCommasToAmount(data?.gst)}</span>
                            </div>
                            <div className="col-6 col-md-2 m-0 p-0 d-flex gap-1 p-2 flex-column">
                                <span className="fs-12px text-black-60">Invoice Amount</span>
                                <span className="fs-14px fw-500">{AddCommasToAmount(data?.invoice_value)}</span>
                            </div>
                            <div className="col-6 col-md-2 m-0 p-0 d-flex gap-1 p-2 flex-column">
                                <span className="fs-12px text-black-60">Sanctioned</span>
                                <span className="fs-14px fw-500">{AddCommasToAmount(data?.sanction_amount)}</span>
                            </div>
                            <div className="col-6 col-md-2 m-0 p-0 d-flex gap-1 p-2 flex-column">
                                <span className="fs-12px text-black-60">Deduction</span>
                                <span className="fs-14px fw-500">{AddCommasToAmount(data?.total_deduction)}</span>
                            </div>
                            <div className="col-6 col-md-2 m-0 p-0 d-flex gap-1 p-2 flex-column">
                                <span className="fs-12px text-black-60">Payment Amount</span>
                                <span className="fs-14px fw-500 text-success-100">{AddCommasToAmount(data?.payable_amount)}</span>
                            </div>
                        </div>
                        {activeDeductions.length > 0 && (
                            <div className="row px-2">
                                {activeDeductions.map((item) => (
                                    <div className="col-6 col-md-3 col-xl-2 m-0 p-0 d-flex gap-1 p-2 flex-column" key={item.key}>
                                        <span className="fs-12px text-black-60">{item.label}</span>
                                        <span className="fs-14px fw-500">{item.amount}</span>
                                    </div>
                                ))}
                            </div>
                        )}

                        <div className="m-0 p-0 text-secondary-100 fs-14px bg-prime-20 mt-2 p-1 fw-500">
                            Bank Accounts
                        </div>

                        <div className="row px-2">
                            <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                                <span className="fs-12px text-black-60">Project Name</span>
                                <span className="fs-14px fw-500">{data?.beneficiary_other_details?.account_details?.project_name}</span>
                            </div>
                            <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                                <span className="fs-12px text-black-60">Account Name</span>
                                <span className="fs-14px fw-500">{data?.beneficiary_other_details?.account_details?.beneficiary_name}</span>
                            </div>
                            <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                                <span className="fs-12px text-black-60 d-flex justify-content-between align-items-center">Bank <i className="icon-info fs-16px"></i> </span>
                                <span className="fs-14px fw-500">{data?.beneficiary_other_details?.account_details?.bank_name}</span>
                            </div>
                            <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                                <span className="fs-12px text-black-60">Account No.</span>
                                <span className="fs-14px fw-500">{data?.beneficiary_other_details?.account_details?.account_no}</span>
                            </div>
                            <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                                <span className="fs-12px text-black-60">IFSC</span>
                                <span className="fs-14px fw-500">{data?.beneficiary_other_details?.account_details?.ifsc_code}</span>
                            </div>
                            
                        </div>
                        {
                            distinctSchemeList.map((scheme, i) => (
                                <div className="row px-2" key={i}>
                                    <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                                        <span className="fs-12px text-black-60">Scheme Account Name</span>
                                        <span className="fs-14px fw-500">{scheme?.bank_details?.account_name}</span>
                                    </div>
                                    <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                                        <span className="fs-12px text-black-60 d-flex justify-content-between align-items-center">Bank <i className="icon-info fs-16px"></i> </span>
                                        <span className="fs-14px fw-500">{scheme?.bank_details?.bank_name}</span>
                                    </div>
                                    <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                                        <span className="fs-12px text-black-60">Branch Name</span>
                                        <span className="fs-14px fw-500">{scheme?.bank_details?.branch_name}</span>
                                    </div>
                                    <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                                        <span className="fs-12px text-black-60">Account No.</span>
                                        <span className="fs-14px fw-500">{scheme?.bank_details?.account_no}</span>
                                    </div>
                                    <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                                        <span className="fs-12px text-black-60">IFSC</span>
                                        <span className="fs-14px fw-500">{scheme?.bank_details?.ifsc_code}</span>
                                    </div>
                                    
                                </div>
                            ))
                        }

                        <div className="m-0 p-0 text-secondary-100 fs-14px bg-prime-20 mt-2 p-1 fw-500">
                            Scheme Utilization
                        </div>

                        {
                            data?.scheme_list.map((scheme, schemeIndex) => (
                                <div key={schemeIndex} style={{borderBottom: '1px solid #ccc'}}>
                                    <div className="row px-2">
                                        <div className="col-9 m-0 p-0 d-flex gap-1 p-2 d-flex align-items-center">
                                            <span className="fs-12px text-black-60">Scheme Name</span>
                                            <span className="fs-14px fw-500">
                                            {scheme.name}
                                            </span>
                                        </div>
                                        <div className="col-3 m-0 p-0 d-flex gap-1 p-2 d-flex align-items-center">
                                            <span className="fs-12px text-black-60">Scheme Code:</span>
                                            <span className="fs-14px fw-500">{scheme.code}</span>
                                        </div>
                                        </div>
                                        <div className="row px-2">
                                        <div className="col-2 m-0 p-0 d-flex gap-1 p-2 d-flex align-items-center">
                                            <span className="fs-12px text-black-60">Grant Code:</span>
                                            <span className="fs-14px fw-500">{scheme.grant_code}</span>
                                        </div>
                                        <div className="col-4 m-0 p-0 d-flex gap-1 p-2 d-flex align-items-center">
                                            <span className="fs-12px text-black-60">Scheme Type:</span>
                                            <span className="fs-14px fw-500">
                                            {scheme.type}
                                            </span>
                                        </div>
                                        <div className="col-3 m-0 p-0 d-flex gap-1 p-2 d-flex align-items-center">
                                            <span className="fs-12px text-black-60">
                                            From Bal. of FY (Var):
                                            </span>
                                            <span className="fs-14px fw-500">{scheme.financial_year}</span>
                                        </div>
                                        <div className="col-3 m-0 p-0 d-flex gap-1 p-2 d-flex align-items-center">
                                            <span className="fs-12px text-black-60">Total Amount:</span>
                                            <span className="fs-14px fw-500">{AddCommasToAmount(scheme.invoice_scheme_amount)}</span>
                                        </div>
                                        </div>
            
                                        <div className="px-2 m-0 mt-1">
                                        <div className="border mb-2 mx-2"></div>
            
                                        <div className="pb-2 d-flex justify-content-between text-secondary-50 px-4">
                                            <button
                                            onClick={() => mainCardSwitch(`subhead_${scheme?.invoice_scheme_id}`, `activity_${scheme?.invoice_scheme_id}`, `subactivity_${scheme?.invoice_scheme_id}`, {scheme_id: scheme?.invoice_scheme_id, subhead: true, activity: false, subActivity: false})}
                                            className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1 rounded-4 ${
                                                activeCard.includes(`subhead_${scheme?.invoice_scheme_id}`) ? "bg-secondary-20" : "bg-white"
                                            } `}
                                            >
                                            {activeCard.includes(`subhead_${scheme?.invoice_scheme_id}`) ? (
                                                <i className="icon-remove_circle_outline"></i>
                                            ) : (
                                                <i className="icon-add_circle_outline"></i>
                                            )}
                                            Sub head
                                            </button>
                                            {
                                                scheme?.is_activity_active && <button
                                            onClick={() => mainCardSwitch(`activity_${scheme?.invoice_scheme_id}`,`subhead_${scheme?.invoice_scheme_id}`, `subactivity_${scheme?.invoice_scheme_id}`, {scheme_id: scheme?.invoice_scheme_id, subhead: false, activity: true, subActivity: false})}
                                            className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4 ${
                                                activeCard.includes(`activity_${scheme?.invoice_scheme_id}`) ? "bg-secondary-20" : "bg-white"
                                            } `}
                                            >
                                            {activeCard.includes(`activity_${scheme?.invoice_scheme_id}`) ? (
                                                <i className="icon-remove_circle_outline"></i>
                                            ) : (
                                                <i className="icon-add_circle_outline"></i>
                                            )}
                                            Activity - Subactivity
                                            </button>
                                                
                                            }
                                        </div>
                                        {activeCard.includes(`subhead_${scheme?.invoice_scheme_id}`) && (
                                            <>
                                            <div className="border mx-2"></div>
                                            <div style={{ overflowX: "auto" }} className="w-100 px-2">
                                                <table className="w-100">
                                                <thead>
                                                    <tr style={{ border: "0" }} className="p-0 m-0">
                                                    <th className="fs-12px text-black-60 border-0 p-1 text-start">
                                                        Subhead Code
                                                    </th>
                                                    <th className="fs-12px text-black-60 border-0 p-1 text-start">
                                                        Subhead Name
                                                    </th>
                                                    <th className="fs-12px text-black-60 border-0 p-1 text-start">
                                                        Subhead Amout
                                                    </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        scheme?.subheads.map((subhead, subheadIndex) => (
                                                            <tr key={subheadIndex}>
                                                                <td className="fs-14px border-0 p-1 text-start">
                                                                {subhead.code}
                                                                </td>
                                                                <td className="fs-14px border-0 p-1 text-start">
                                                                {subhead.name}
                                                                </td>
                                                                <td className="fs-14px border-0 p-1 text-start">
                                                                {AddCommasToAmount(subhead.subhead_amount)}
                                                                </td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                                </table>
                                            </div>
                                            </>
                                        )}
            
                                        {activeCard.includes(`activity_${scheme?.invoice_scheme_id}`) && (
                                            <>
                                            <div className="border mx-2"></div>
                                            <div className=" pb-2 d-flex flex-column gap-1 mt-2 mx-0 px-2">
                                                <Accordion activeKey={activeKeys} style={{ border: "0", marginTop: "5px" }}>
                                                    {groupActivitiesByName(scheme?.subheads).map((activityGroup) => {
                                                    const eventKey = `activity_${scheme?.invoice_scheme_id}_${activityGroup?.activity_id}`;
            
                                                    return (
                                                        <Accordion.Item
                                                        key={eventKey}
                                                        eventKey={eventKey}
                                                        style={{ borderRadius: "0", border: "0", marginBottom: "10px" }}
                                                        >
                                                        <Accordion.Header onClick={() => toggleAccordion(eventKey)}>
                                                            <div className="w-100 d-flex justify-content-between">
                                                            <span>{activityGroup?.activity}</span>
                                                            <span
                                                                className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                                style={{
                                                                height: "13.33px",
                                                                width: "13.33px",
                                                                }}
                                                            >
                                                                {activeKeys.includes(eventKey) ? "-" : "+"}
                                                            </span>
                                                            </div>
                                                        </Accordion.Header>
            
                                                        <Accordion.Body>
                                                            <div style={{ overflowX: "auto" }} className="w-100 px-2">
                                                            <table className="w-100">
                                                                <thead>
                                                                <tr style={{ border: "0" }} className="p-0 m-0">
                                                                    <th className="fs-12px text-black-60 border-0 p-1 text-start" style={{ width: "50%" }}>
                                                                    Sub-Activity
                                                                    </th>
                                                                    <th className="fs-12px text-black-60 border-0 p-1 text-start" style={{ width: "25%" }}>
                                                                    Amount
                                                                    </th>
                                                                    <th className="fs-12px text-black-60 border-0 p-1 text-start" style={{ width: "25%" }}>
                                                                    Deduction
                                                                    </th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {activityGroup?.subactivities.map((subactivityItem, subIndex) => (
                                                                    <tr key={`${eventKey}_${subactivityItem?.subactivity_id}_${subIndex}`}>
                                                                    <td className="fs-14px border-0 p-1 text-start">{subactivityItem?.subactivity}</td>
                                                                    <td className="fs-14px border-0 p-1 text-start">{AddCommasToAmount(subactivityItem?.amount)}</td>
                                                                    <td className="fs-14px border-0 p-1 text-start">{AddCommasToAmount(subactivityItem?.activity_deduction)}</td>
                                                                  </tr>
                                                                ))}
                                                                </tbody>
                                                                <tfoot>
                                                                <tr className="p-0 m-0" style={{ backgroundColor: "#def0ff", borderTop: "2px solid #28326f" }}>
                                                                    <td className="fs-14px fw-600 text-black-100 border-0 text-start p-0" style={{ width: "50%" }}>
                                                                    Total
                                                                    </td>
                                                                    <td className="fs-14px fw-600 text-black-100 border-0 text-start p-0" style={{ width: "25%" }}>
                                                                    {AddCommasToAmount(activityGroup?.subactivities.reduce((sum, sub) => sum + Number(sub?.amount || 0), 0))}
                                                                    </td>
                                                                    <td className="fs-14px fw-600 text-black-100 border-0 text-start p-0" style={{ width: "25%" }}>
                                                                    {AddCommasToAmount(activityGroup?.subactivities.reduce((sum, sub) => sum + Number(sub?.activity_deduction || 0), 0))}
                                                                    </td>
                                                                  </tr>
                                                                </tfoot>
                                                            </table>
                                                            </div>
                                                        </Accordion.Body>
                                                        </Accordion.Item>
                                                    );
                                                    })}
                                                </Accordion>
                                            </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            ))
                        }


                    </Row>
                </div>

                <Row className="pt-5">
                    <Col sm="6">
                        <FormControl fullWidth>
                            <TextField
                                label="Amount to Approve"
                                value={data.sanction_amount ? AddCommasToAmount(data.sanction_amount) : 0}
                                inputProps={{ maxLength: 50 }}
                                readOnly={true}
                            />
                        </FormControl>
                    </Col>
                    <Col sm="6 mb-2">
                        <FormControl fullWidth>
                            <TextField
                                label="L1 Remarks"
                                value={data.remarks}
                                inputProps={{ maxLength: 50 }}
                                disabled={true}
                            />
                        </FormControl>
                    </Col>
                    <Col sm="6 mb-2">
                        <FormControl fullWidth>
                            <TextField
                                label="L2 Remarks"
                                value={l2remarks}
                                inputProps={{ maxLength: 50 }}
                                disabled={authData.user.user_type !== 'l2'}
                                onChange={(e) => setl2Remarks(e.target.value)}
                            />
                        </FormControl>
                    </Col>
                    <Col sm="6 mb-2">
                        <FormControl fullWidth>
                            <TextField
                                label="L3 Remarks"
                                value={l3remarks}
                                inputProps={{ maxLength: 50 }}
                                disabled={authData.user.user_type !== 'l3'}
                                onChange={(e) => setl3Remarks(e.target.value)}
                            />
                        </FormControl>
                    </Col>
                    
                    <Col md="12">
                        <div className="d-flex justify-content-center align-items-center gap-3 flex-wrap">
                            {authData.user.user_type === 'l3' ? (
                                <>
                                    {data.l3_approval_status < 1 ? (
                                        <>
                                            <button type="button" className='submit_button'
                                                    style={{ width: '180px', padding: '8px 14px' }}
                                                    onClick={() => previewHandler(1)}>
                                                Approve
                                            </button>
                                            <button className='reject_button'
                                                    style={{ width: '180px', padding: '8px 14px' }}
                                                    onClick={() => previewHandler(2)}>
                                                Reject
                                            </button>
                                        </>
                                    ) : data.l3_approval_status == 1 ? (
                                        <Button variant="primary" disabled={true} size="lg">
                                            Already Approved
                                        </Button>
                                    ) : (
                                        <Button variant="outline-danger" disabled={true} size="lg">
                                            Already Rejected
                                        </Button>
                                    )
                                    }
                                </>
                            ) : (
                                <>
                                    {data.approval_status < 1 ? (
                                        <>
                                            <button type="button" className='submit_button'
                                                    style={{ width: '180px', padding: '8px 14px' }}
                                                    onClick={() => previewHandler(1)}>
                                                Approve
                                            </button>
                                            <button className='reject_button'
                                                    style={{ width: '180px', padding: '8px 14px' }}
                                                    onClick={() => previewHandler(2)}>
                                                Reject
                                            </button>
                                        </>
                                    ) : data.approval_status == 1 ? (
                                        <Button variant="primary" disabled={true} size="lg">
                                            Already Approved
                                        </Button>
                                    ) : (
                                        <Button variant="outline-danger" disabled={true} size="lg">
                                            Already Rejected
                                        </Button>
                                    )
                                    }
                                </>
                            )}
                        </div>
                    </Col>
                </Row>
            </Card>

        </div>
    )
}

export default ProceedForApproval
